import PropTypes from 'prop-types';
import React from 'react';
import { InteractionsContent } from './internal/components/InteractionsContent';
import { InteractionsProvider } from './internal/context/InteractionsContext';

export function StructuredInteractions({
  client,
  currentEmployee,
  isClientsDrawer,
  provider,
}) {
  return (
    <InteractionsProvider
      client={client}
      currentEmployee={currentEmployee}
      isClientsDrawer={isClientsDrawer}
      provider={provider}
    >
      <InteractionsContent />
    </InteractionsProvider>
  );
}

StructuredInteractions.propTypes = {
  client: PropTypes.shape({ id: PropTypes.string }),
  currentEmployee: PropTypes.shape({ id: PropTypes.string }),
  isClientsDrawer: PropTypes.bool,
  provider: PropTypes.shape({ id: PropTypes.string }),
};

StructuredInteractions.defaultProps = {
  client: undefined,
  currentEmployee: undefined,
  isClientsDrawer: false,
  provider: undefined,
};
